import axios from "axios";
import type { AxiosError, AxiosInstance } from "axios";

/**
 * Axios instance pointing at the Fastify backend. In dev, Vite proxies /api
 * → http://localhost:3001 so the same relative path works in both environments.
 * Auth is httpOnly `authToken` cookie (withCredentials) — no Bearer in JS.
 */
const baseURL = import.meta.env.VITE_API_BASE_URL ?? "";

export const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  timeout: 8000,
});

let onUnauthorized: (() => void) | null = null;

/** Registered by the router so this module stays free of store/router imports. */
export function setUnauthorizedHandler(fn: (() => void) | null) {
  onUnauthorized = fn;
}

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ error?: string; redirectTo?: string }>) => {
    if (err.response?.status === 401) {
      const detail = err.response.data?.error;
      err.message = detail ?? "Authentication required";
      if (!(err.config?.url ?? "").includes("/api/auth/")) onUnauthorized?.();
    }
    return Promise.reject(err);
  }
);

export type ApiError = { error: string; redirectTo?: string };
